module.exports = __webpack_public_path__ + "img/11.beb7910e.jpg";